// extracted by mini-css-extract-plugin
export default {"footerContent":"SignedCommitFooter-module__footerContent--Zu2A_","Link":"SignedCommitFooter-module__Link--uRCMq","Link_1":"SignedCommitFooter-module__Link_1--teVEy"};